export default __webpack_public_path__ + "static/Globhe_symbol_2022_Coolgrey-7606048280f1c273be29bb495f07218e.png";